import React from 'react';
import {
  DocumentTextIcon,
  SparklesIcon,
  ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';

export default function StatsCards({ stats, loading }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="bg-white rounded-lg shadow-md p-6 animate-pulse"
          >
            <div className="h-12 bg-gray-200 rounded mb-4"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Total PYQs',
      value: stats?.totalQuestions || 0,
      icon: DocumentTextIcon,
      gradient: 'from-blue-500 to-indigo-600',
      details: stats?.byPaperType
        ? Object.entries(stats.byPaperType)
            .map(([paperType, count]) => `${paperType}: ${count}`)
            .join(', ')
        : 'No data',
    },
    {
      title: 'By Subject',
      value: stats?.bySubject ? Object.keys(stats.bySubject).length : 0,
      icon: SparklesIcon,
      gradient: 'from-purple-500 to-pink-600',
      details: stats?.bySubject
        ? Object.entries(stats.bySubject)
            .slice(0, 3)
            .map(([subject, count]) => `${subject}: ${count}`)
            .join(', ')
        : 'No data',
    },
    {
      title: 'By Year',
      value: stats?.byYear ? Object.keys(stats.byYear).length : 0,
      icon: ClipboardDocumentCheckIcon,
      gradient: 'from-emerald-500 to-green-600',
      details: stats?.byYear
        ? Object.entries(stats.byYear)
            .slice(0, 3)
            .map(([year, count]) => `${year}: ${count}`)
            .join(', ')
        : 'No data',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {cards.map((card, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow"
        >
          <div className={`bg-gradient-to-r ${card.gradient} p-1`}></div>
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <card.icon className="h-8 w-8 text-gray-400" />
              <div
                className={`text-3xl font-bold bg-gradient-to-r ${card.gradient} bg-clip-text text-transparent`}
              >
                {card.value.toLocaleString()}
              </div>
            </div>
            <h3 className="text-sm font-medium text-gray-900 mb-2">
              {card.title}
            </h3>
            <p className="text-xs text-gray-500 truncate" title={card.details}>
              {card.details}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
